import { render, staticRenderFns } from "./HcpcCheck.vue?vue&type=template&id=5b924407"
import script from "./HcpcCheck.vue?vue&type=script&lang=js"
export * from "./HcpcCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports